import { DAYS } from "./constantValues";

export function getOpeningStatusWithTime(restaurant) {
  const openingTimes = restaurant?.openingTimes ?? [];
  if (!openingTimes.length) {
    return { isOpen: false, label: null };
  }

  const now = new Date();
  const todayIndex = now.getDay();
  const currentMinutes = now.getHours() * 60 + now.getMinutes();
  const dayLabelByCode = {
    SUN: "sunday",
    MON: "monday",
    TUE: "tuesday",
    WED: "wednesday",
    THU: "thursday",
    FRI: "friday",
    SAT: "saturday",
  };

  const toMinutes = (time) =>
    Number(time?.[0] ?? 0) * 60 + Number(time?.[1] ?? 0);
  const toDisplayTime = (time) => {
    const hours24 = Number(time?.[0] ?? 0);
    const minutes = Number(time?.[1] ?? 0);
    const date = new Date();
    date.setHours(hours24, minutes, 0, 0);
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  const todayTimings = openingTimes.find((o) => o.day === DAYS[todayIndex]);
  const sortedTodayTimes = [...(todayTimings?.times ?? [])].sort(
    (a, b) => toMinutes(a.startTime) - toMinutes(b.startTime)
  );

  for (const slot of sortedTodayTimes) {
    const start = toMinutes(slot.startTime);
    const end = toMinutes(slot.endTime);

    if (currentMinutes >= start && currentMinutes <= end) {
      return { isOpen: true, label: "Open now" };
    }

    if (currentMinutes < start) {
      return {
        isOpen: false,
        label: `Opens today at ${toDisplayTime(slot.startTime)}`,
      };
    }
  }

  for (let offset = 1; offset <= 7; offset++) {
    const dayIndex = (todayIndex + offset) % 7;
    const dayCode = DAYS[dayIndex];
    const schedule = openingTimes.find((o) => o.day === dayCode);
    if (!schedule?.times?.length) continue;

    const sortedTimes = [...schedule.times].sort(
      (a, b) => toMinutes(a.startTime) - toMinutes(b.startTime)
    );
    const nextSlot = sortedTimes[0];
    const dayText =
      offset === 1 ? "tomorrow" : dayLabelByCode[dayCode] ?? "another day";

    return {
      isOpen: false,
      label: `Opens ${dayText} at ${toDisplayTime(nextSlot.startTime)}`,
    };
  }

  return { isOpen: false, label: null };
}

export function isRestaurantClosed(restaurant) {
  const openingStatus = getOpeningStatusWithTime(restaurant);
  return !restaurant?.isAvailable || !openingStatus.isOpen;
}
